// Module: today — «اليوم» (HANDOFF-erp-web §3 / §5.1). The appointment panel
// (?appointment=<id>) opens over this page; the calendar module reuses the
// panel, the staff grid and the data layer from this folder.

import { CalendarDays } from 'lucide-react';
import { defineModule } from '@/app/module-types';

export default defineModule({
  key: 'today',
  label: 'المواعيد',
  icon: CalendarDays,
  flag: 'erp.core',
  minRole: 'staff',
  rail: 'appointments',
  routes: [{ path: '/today', lazy: () => import('./screens/Today').then((m) => ({ Component: m.default })) }],
  menu: [{ key: 'today', label: 'اليوم', to: '/today' }],
});
